<template>
  <v-tooltip
    bottom
    open-on-click
    max-width="280"
  >
    <template v-slot:activator="{ on, attrs }">
      <component
        :is="interactive ? 'v-btn' : 'v-chip'"
        small
        label
        outlined
        class="record-privacy"
        :color="status.effective_public ? 'success' : 'error'"
        :loading="loading"
        :disabled="disabled || loading"
        :aria-pressed="interactive ? String(recordEnabled) : undefined"
        :aria-label="`${status.effective_public ? 'Public' : 'Private'}: ${explanation}`"
        tabindex="0"
        v-bind="attrs"
        v-on="on"
        @click.stop="toggle"
      >
        <v-icon
          left
          small
        >
          {{ status.effective_public ? mdiEye : mdiEyeOff }}
        </v-icon>
        {{ status.effective_public ? 'Public' : 'Private' }}
      </component>
    </template>
    <span>{{ explanation }}</span>
  </v-tooltip>
</template>

<script>
import { mdiEye, mdiEyeOff } from '@mdi/js'
import {
  enabled, categoryPolicy, visibility, privacyExplanations,
} from '@/utils/recordPrivacy'

export default {
  props: {
    record: { type: Object, default: () => ({}) },
    categories: { type: Array, default: null },
    diary: { type: Boolean, default: false },
    interactive: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
  data: () => ({ mdiEye, mdiEyeOff }),
  computed: {
    recordEnabled() { return enabled(this.record.public) },
    status() {
      if (this.diary) return { effective_public: false, privacy_reason: 'diary' }
      const { user } = this.$store.state
      const profilePublic = user && user.extra_data && user.extra_data.public
      if (!enabled(profilePublic)) return { effective_public: false, privacy_reason: 'profile' }
      if (this.categories) return visibility(this.record, profilePublic, categoryPolicy(this.categories))
      if (!enabled(this.record.public)) return { effective_public: false, privacy_reason: 'record' }

      return {
        effective_public: enabled(this.record.effective_public),
        privacy_reason: this.record.privacy_reason || 'unknown',
      }
    },
    explanation() {
      const reason = privacyExplanations[this.status.privacy_reason] || privacyExplanations.unknown

      return this.interactive ? `Record setting: ${this.recordEnabled ? 'Public' : 'Private'}. ${reason} Click to change the record setting.` : reason
    },
  },
  methods: {
    toggle() {
      if (this.interactive && !this.disabled && !this.loading) this.$emit('toggle', !this.recordEnabled)
    },
  },
}
</script>

<style scoped>
.record-privacy { flex-shrink: 0; max-width: 100%; vertical-align: middle; }
.record-privacy.v-btn { text-transform: none; letter-spacing: normal; min-width: 0; }
</style>
